import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const NuveiPaymentMob = () => {
  return <CommonProcess />;
};

export default NuveiPaymentMob;
